import HTTP from '@/plugins/http';

const deviceApi = {
  vcbValid: '/sys/pay/bank/confirmLogin',
  vcbLogin: '/sys/pay/bank/vcbLogin',
  listpage: '/momoDevices/list/page',
  insert: '/momoDevices/insert',
  update: '/momoDevices/update',
  deletes: '/momoDevices/delete',
  histrans: '/devices/histrans/momo/list',
  m_h_list: '/devices/histrans/momo/list',
  export: '/devices/histrans/momo/export',
  alldel: '/devices/batch/delete',
  alledite: '/devices/batch/update',
  manualmakeup: '/history/manualmakeup'
};

function listpage(data) {
  return HTTP({
    url: deviceApi.listpage,
    method: 'post',
    data
  });
}
function req_vcbLogin(id) {
  return HTTP.loading({
    url: deviceApi.vcbLogin,
    method: 'get',
    params: { id }
  });
}

function req_vcbValid(params) {
  return HTTP.loading({
    url: deviceApi.vcbValid,
    method: 'post',
    data: params
  });
}

function z_listpage(data) {
  return HTTP({
    url: '/zaloDevices/list/page',
    method: 'post',
    data
  });
}
function v_listpage(data) {
  return HTTP({
    url: '/viettelDevices/list/page',
    method: 'post',
    data
  });
}

function b_listpage(data) {
  return HTTP({
    url: '/sys/pay/bank/list',
    method: 'post',
    data
  });
}
function insert(params) {
  return HTTP({
    url: deviceApi.insert,
    method: 'post',
    data: params
  });
}
function z_insert(params) {
  return HTTP({
    url: '/zaloDevices/insert',
    method: 'post',
    data: params
  });
}
function v_insert(params) {
  return HTTP({
    url: '/viettelDevices/insert',
    method: 'post',
    data: params
  });
}
function b_insert(params) {
  return HTTP({
    url: '/sys/pay/bank/insert',
    method: 'post',
    data: params
  });
}

function update(params) {
  return HTTP({
    url: deviceApi.update,
    method: 'post',
    data: params
  });
}
function z_update(params) {
  return HTTP({
    url: '/zaloDevices/update',
    method: 'post',
    data: params
  });
}
function v_update(params) {
  return HTTP({
    url: '/viettelDevices/update',
    method: 'post',
    data: params
  });
}
function b_update(params) {
  return HTTP({
    url: '/sys/pay/bank/update',
    method: 'post',
    data: params
  });
}

function deletes(params) {
  return HTTP.loading({
    url: deviceApi.deletes,
    method: 'get',
    params
  });
}
function z_deletes(params) {
  return HTTP.loading({
    url: '/zaloDevices/delete',
    method: 'get',
    params
  });
}
function v_deletes(params) {
  return HTTP.loading({
    url: '/viettelDevices/delete',
    method: 'get',
    params
  });
}

function b_deletes(params) {
  return HTTP.loading({
    url: '/sys/pay/bank/delete',
    method: 'get',
    params
  });
}

function histrans(params) {
  return HTTP({
    url: deviceApi.histrans,
    method: 'post',
    data: params
  });
}
function z_histrans(params) {
  return HTTP({
    url: '/devices/histrans/zalo/list',
    method: 'post',
    data: params
  });
}

function v_histrans(params) {
  return HTTP({
    url: '/devices/histrans/viettel/list',
    method: 'post',
    data: params
  });
}
function m_h_list(data) {
  return HTTP({
    url: deviceApi.m_h_list,
    method: 'post',
    data
  });
}
function z_h_list(data) {
  return HTTP({
    url: '/devices/histrans/zalo/list',
    method: 'post',
    data
  });
}

function v_h_list(data) {
  return HTTP({
    url: '/devices/histrans/viettel/list',
    method: 'post',
    data
  });
}

function b_h_list(data) {
  return HTTP.loading({
    url: 'sys/pay/bank/history/list',
    method: 'post',
    data
  });
}
function m_h_statistics(data) {
  return HTTP({
    url: '/devices/histrans/momo/statistics',
    method: 'post',
    data
  });
}
function z_h_statistics(data) {
  return HTTP({
    url: '/devices/histrans/zalo/statistics',
    method: 'post',
    data
  });
}

function v_h_statistics(data) {
  return HTTP({
    url: '/devices/histrans/viettel/statistics',
    method: 'post',
    data
  });
}
function b_h_statistics(data) {
  return HTTP({
    url: '/sys/pay/bank/statistics',
    method: 'post',
    data
  });
}
function doExport(data, type = 'momo') {
  return HTTP.loading({
    url: `/devices/histrans/${type}/export`,
    method: 'post',
    data,
    responseType: 'blob'
  });
}
function alldels(data) {
  return HTTP({
    url: deviceApi.alldel,
    method: 'post',
    data
  });
}
function alledite(data) {
  return HTTP({
    url: deviceApi.alledite,
    method: 'post',
    data
  });
}
function offOrturn(data) {
  return HTTP({
    url: deviceApi.alledite,
    method: 'post',
    data
  });
}
function downtemp() {
  return HTTP({
    url: '/devices/import/template',
    method: 'get',
    responseType: 'blob'
  });
}

function doExportin(data) {
  return HTTP({
    url: '/devices/import',
    method: 'post',
    data
  });
}

function bank_draw_list(data) {
  return HTTP({
    url: '/sys/pay/bank/withdrawak/list',
    method: 'post',
    data
  });
}
function bank_draw_confirm(data) {
  return HTTP.loading({
    url: '/sys/pay/bank/withdrawak/confirm',
    method: 'post',
    data
  });
}
function bank_draw_create(data) {
  return HTTP({
    url: '/sys/pay/bank/withdrawak/create',
    method: 'post',
    data
  });
}
function bank_draw_option(data) {
  return HTTP({
    url: '/sys/bankInfo',
    method: 'get',
    data
  });
}
function bank_balance(data) {
  return HTTP({
    url: '/sys/pay/bank/statistics',
    method: 'post',
    data
  });
}
function subAccountlist(data) {
  return HTTP({
    url: '/merchant/subAccount/list/page',
    method: 'post',
    data
  });
}

function zalo_draw_list(data) {
  return HTTP({
    url: '/devices/zalo/withdraw/page',
    method: 'post',
    data
  });
}
//-----------momo---------
function momo_draw_list(data) {
  return HTTP({
    url: '/devices/momo/withdraw/page',
    method: 'post',
    data
  });
}

function viettel_draw_list(data) {
  return HTTP({
    url: '/devices/viettel/withdraw/page',
    method: 'post',
    data
  });
}

function doExport_draw(data, type = 'momo') {
  return HTTP.loading({
    url: `/devices/${type}/withdraw/excel`, //zalo,viettel,momo
    method: 'post',
    data,
    responseType: 'blob'
  });
}
function doExport_h_bank(data) {
  //------银行提款历史记录导出
  return HTTP.loading({
    url: '/sys/pay/bank/history/export',
    method: 'post',
    data,
    responseType: 'blob'
  });
}

function doExport_bank(data) {
  //------银行提款历史记录导出
  return HTTP.loading({
    url: '/sys/pay/bank/withdrawak/export',
    method: 'post',
    data,
    responseType: 'blob'
  });
}

function getBalance(data) {
  return HTTP.loading({
    url: '/sys/pay/bank/getBalance',
    method: 'post',
    data
  });
}

function doManualmakeup(data) {
  return HTTP.loading({
    url: deviceApi.manualmakeup,
    method: 'post',
    data
  });
}

export default {
  subAccountlist,
  bank_balance,
  bank_draw_option,
  bank_draw_create,
  bank_draw_confirm,
  m_h_statistics,
  listpage,
  insert,
  deletes,
  histrans,
  update,
  m_h_list,
  doExport,
  alldels,
  alledite,
  offOrturn,
  downtemp,
  z_listpage,
  z_insert,
  z_update,
  z_deletes,
  z_h_list,
  z_h_statistics,
  z_histrans,
  v_listpage,
  v_histrans,
  v_insert,
  v_update,
  v_deletes,
  v_h_list,
  v_h_statistics,
  b_listpage,
  b_insert,
  b_update,
  b_deletes,
  b_h_list,
  b_h_statistics,
  bank_draw_list,
  zalo_draw_list,
  momo_draw_list,
  viettel_draw_list,
  doExport_draw,
  doExport_bank,
  doExport_h_bank,
  doExportin,
  req_vcbLogin,
  req_vcbValid,
  getBalance,
  doManualmakeup
};



// WEBPACK FOOTER //
// ./src/api/device.js